import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { MaterialList } from './MaterialList'
import { MaterialsProps } from './types'

export const Materials: FC<MaterialsProps> = ({
  seo,
  header,
  footer,
  content: {
    breadcrumb,
    title,
    subtitle,
    description,
    second_title,
    second_description,
    featured_img,
    materials,
    download
  }
}) => (
  <Page seo={seo} header={header} footer={footer}>
    <Featured
      breadcrumb={breadcrumb}
      title={title}
      subtitle={subtitle}
      description={description}
      second_title={second_title}
      second_description={second_description}
      featured_img={featured_img}
    />
    <MaterialList materials={materials} download={download} />
  </Page>
)
